export const C__LanguageSelector = () => ({
    isOpen: false,

    toggle() {
        this.isOpen = !this.isOpen;
    }
});
